import React from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MultipleFileUpload from './Components/MultipleFileUpload';
import   NavBar from "./Components/nav-bar";
import { useAuth0 } from '@auth0/auth0-react';
import HamsterAnimation from './animation/loader'
import Profile from './Components/profile';
import ProtectedRoute from './auth/protected-route';
import LandingPage from './Components/LandingPage';
import Registro from './Components/registrocitamedica';
import Transcription from './Components/realtime/Transcription';
import Transcriptionbeta from './Components/realtime/Transcriptionbeta';
import Webmdnbeta from './Components/Webmdnbeta';

function App() {
  const { isLoading } = useAuth0();

  return (
    <div className="App">
      <h1>MDT</h1>
      <NavBar />
      {isLoading ? (
        <HamsterAnimation />
      ) : (
        <Routes>
          <Route path="/tool" element={<ProtectedRoute />}>
            <Route index element={<MultipleFileUpload />} /> </Route>
            <Route path="/webmdn" element={<ProtectedRoute />}>
            <Route index element={<Webmdnbeta />} /> </Route>
            <Route path="/beta" element={<ProtectedRoute />}>
            <Route index element={<Transcriptionbeta />} /> </Route>
            <Route path="/realtime" element={<ProtectedRoute />}>
            <Route index element={<Transcription />} /> </Route>
            <Route path="/pure" element={<ProtectedRoute />}>
            <Route index element={<Registro />} /> </Route>
            <Route path="/profile" element={<ProtectedRoute />}>
            <Route index element={<Profile />} /> </Route>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      )}
      <div className="footer">
      MDT Intelifencia Artificial aplicada a la Medicina
      </div>
    </div>
  );
}

export default App;

